import {Injectable} from '@angular/core';
import {GeneralService} from './general.service';
import {Base64} from '@ionic-native/base64/ngx';

@Injectable({
    providedIn: 'root'
})
export class ReadBase64Service {

    constructor(private generalServices: GeneralService,
                private base64: Base64) {
    }

    async formBase64(imgEntry) {
        await this.base64.encodeFile(imgEntry).then((base64File: string) => {
            console.log(base64File);
            return base64File;
        }, (err) => {
            console.log(err);
        });
    }
}
